<div class="db-image-optimizer-webp" *ngIf="!websiteHosted">

  <div class="db-image-optimizer-webp__content">

    <div class="db-activate-booster mb30" *ngIf="!boosterPluginIsActive">
      <div>
        <div class="db-activate-booster-header mb2"><img class="mr8" src="assets/images/booster/activate-booster.svg" alt=""/><p>10Web Booster
          {{currentSubscription?.trialBoosterClient ? 'Free' : 'Pro'}}</p></div>
        <span
          class="db-activate-booster-desc">Go a step further and optimize your entire website, not just images.</span>
      </div>
      <a dbWpLink class="ds-btn-green"
         [ngClass]="{'ds-btn-disabled': loading}"
         [adminLink]="website?.adminActivateBoosterUrl" [websiteId]="website?.id"
         target="_blank" rel="noopener">
        <span>Activate Booster</span>
      </a>
    </div>

    <div class="db-form">
    <form [formGroup]="imageOptimizerSettings">
      <div *ngIf="!pageLayout"
           class="db-optimize-images__block"  [ngClass]="{'ds-lazy-load': (loadingWebpFormat || loading) && !pageLayout}">
        <div>
          <div>
            <p class="db-optimize-images__block-title" [innerHTML]="'text_speedOptimizerWebPFormat' | dbText"></p>
            <span class="db-optimize-images__block-desc"
                  [innerHTML]="(!boosterPluginIsActive || (boosterSettings && !boosterSettings?.webpStatus && !['10Web', 'NGINX',
                  'APACHE'].includes(boosterSettings.hosting) || !boosterSettings?.webpDeliveryWorking) ? 'text_speedOptimizerServeImagesWebPFormat' : websiteHosted ?
                  'text_speedOptimizerWebPFormatHostedDesc' :
                  'text_speedOptimizerWebPFormatDesc') | dbText"></span>
          </div>
          <div class="db-switch-wrap" *ngIf="(!!boosterSettings?.webpDeliveryWorking && boosterSettings?.hosting !== 'NGINX') || (!boosterPluginIsActive && ioPluginIsActive)" [ngClass]="{'db-withIO': (!boosterPluginIsActive && ioPluginIsActive)}">
            <input id="webp-switcher" class="ds-switcher-green ds-control-small auto-optimize-settings" type="checkbox"
                   (change)="setWebpStatus()" formControlName="webpStatus" [value]="boosterSettings?.webpStatus">
            <label for="webp-switcher">
              <span class="ds-switcher-control"></span>
            </label>
          </div>
        </div>

        <hr class="separator mt25" *ngIf="(websiteId && boosterSettings && !websiteHosted
        && ((!boosterSettings?.webpStatus && !['10Web', 'NGINX', 'APACHE'].includes(boosterSettings.hosting)) || !boosterSettings?.webpDeliveryWorking)) || (!boosterPluginIsActive && ioPluginIsActive)">

        <div class="db-optimize-images__note mt25" *ngIf="(websiteId && boosterSettings && !websiteHosted
        && ((!boosterSettings?.webpStatus && !['10Web', 'NGINX', 'APACHE'].includes(boosterSettings.hosting)) || !boosterSettings?.webpDeliveryWorking)) || (!boosterPluginIsActive && ioPluginIsActive)">
          <div>
            <h3 [innerHTML]="'text_serverConfiguration' | dbText"></h3>
            <div>
              <div class="db-optimize-images__note-info">
                <p class="db-optimize-images__block-desc note">
                  <span [innerHTML]="'text_speedOptimizerNote' | dbText | lowerCaseSpecificWords"></span>
                  <a (click)="showWebPServerDialog()">these instructions</a>
                </p>
                <p class="db-optimize-images__block-desc note">
                  <span [innerHTML]="'text_speedOptimizerNoteAfterCompleting' | dbText"></span>
                </p>
              </div>
              <div class="db-optimize-images__webp-status" (click)="getWebpStatus()"
                   [ngClass]="{'active': webpServerConfigIsActive, 'inactive': !webpServerConfigIsActive}" *ngIf="boosterPluginIsActive">
                <p>
                  <i class="db-icon db-icon-{{webpServerConfigIsActive ? 'ds-circle-filled' : 'ds-close-bg'}}"></i>
                  <span>{{webpServerConfigIsActive ? 'Active' : 'Inactive'}}</span>
                </p>
                <i class="db-icon db-icon-ds-refresh"></i>
              </div>
            </div>
          </div>
        </div>

        <hr class="separator mt25" *ngIf="websiteId && !websiteHosted && boosterSettings &&
        ((!boosterSettings?.webpStatus && !['10Web', 'NGINX', 'APACHE'].includes(boosterSettings.hosting)) || !boosterSettings?.webpDeliveryWorking) && !webpServerConfigIsActive">

        <div class="db-optimize-images__note use-picture mt25"
             *ngIf="websiteId && !websiteHosted && boosterSettings && ((!boosterSettings?.webpStatus && !['10Web', 'NGINX', 'APACHE'].includes(boosterSettings.hosting)) || !boosterSettings?.webpDeliveryWorking) && !webpServerConfigIsActive">
          <div>
            <h3>{{'text_usePictureTags' | dbText}}</h3>
            <div>
              <div class="db-optimize-images__note-info">
                <p class="db-optimize-images__block-desc note">
                  <span>{{'text_usePictureTagsDesc1' | dbText}}</span>
                </p>
                <p class="db-optimize-images__block-desc note">
                  <span>{{'text_usePictureTagsDesc2' | dbText}}</span>
                </p>
              </div>
              <div class="db-switch-wrap">
                <input id="picture-tag-switcher" class="ds-switcher-green ds-control-small auto-optimize-settings" type="checkbox"
                       (change)="setWebpStatus()" formControlName="pictureWebpStatus">
                <label for="picture-tag-switcher">
                  <span class="ds-switcher-control"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    </div>

  </div>
</div>
